import { render, staticRenderFns } from "./yhubTrendTem.vue?vue&type=template&id=5daa8e2a&scoped=true"
import script from "./yhubTrendTem.vue?vue&type=script&lang=js"
export * from "./yhubTrendTem.vue?vue&type=script&lang=js"
import style0 from "./yhubTrendTem.vue?vue&type=style&index=0&id=5daa8e2a&prod&lang=scss&scoped=true"
import style1 from "./yhubTrendTem.vue?vue&type=style&index=1&id=5daa8e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daa8e2a",
  null
  
)

export default component.exports